import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import "./style/app.css";
import "./style/style.css";
import React, { useEffect, useContext, useCallback } from "react";
import "./style/adminhome.css";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import Main from "./components/Main";
import api_url from "./constants";
import axios from "axios";
import io from "socket.io-client";
import "./utils/xsrf";
import { ReqCallContext, ReqCallProvider } from "./context/ReqCallContext";
import Footer from "./components/common/Footer";
// Cookie-only auth: every API call must carry the session cookie.
axios.defaults.withCredentials = true;
const Spinner = React.lazy(() => import("./components/Spinner"));
const Login = React.lazy(() => import("./components/Login"));
const ENDPOINT = process.env.NODE_ENV ===  "development" ? "http://localhost:9001" : "https://fly247-api-849433205741.asia-south1.run.app"; ;

function App() {
  const [userContext, setUserContext] = useContext(AuthContext);
  const [reqCall, setReqCall] = useContext(ReqCallContext);
  const navigate = useNavigate();
  const verifyUser = async () => {
    try {
      if (userContext.token) {
        const response = await axios.post(
          api_url + "/auth/checkAdminActive",
          {},
          {
            headers: {
              "Content-Type": "application/json",
            },
            withCredentials: true,
          }
        );
        if (response.status === 200) {
          const data = response.data;
          setUserContext((oldValues) => {
            // Cookie-only auth: no token in body; keep the login marker and
            // refresh details. Never write data.token (undefined wipes login).
            // MERGE (not replace): checkAdminActive returns a minimal user
            // object without match_share/match_commission, so a replace would
            // wipe them and the "My Share" columns render NaN%.
            return {
              ...oldValues,
              token: oldValues.token || "cookie",
              details: {
                ...(oldValues.details || {}),
                ...(data.user || data.details || {}),
              },
            };
          });
        }
      }
    } catch (error) {
      setUserContext((oldValues) => {
        return { ...oldValues, token: null };
      });
    }
  };

  useEffect(() => {
    verifyUser();
  }, [reqCall]);
  const syncLogout = useCallback((event) => {
    if (event.key === "adminLogout") {
      // If using react-router-dom, you may call history.push("/")
      window.location.reload();
      navigate("/");
    }
  }, []);
  useEffect(() => {
    window.addEventListener("storage", syncLogout);
    return () => {
      window.removeEventListener("storage", syncLogout);
    };
  }, [syncLogout]);
  useEffect(() => {
    if (userContext.token && userContext.details) {
      const socket = io(ENDPOINT, {
        path: "/socket/odds/",
        transports: ["polling"],
      });
      socket.on("connect", () => {
        console.log("connected to socket");
      });
      socket.emit("authenticate", {
        username: userContext.details.username,
        level: userContext.details.level,
      });
      socket.on("disconnect", () => {
        console.log("disconnected from socket");
      });
      return () => {
        socket.disconnect();
      };
    }
  }, [userContext.token, userContext.details]);
  return (
    <div className="app">
      <React.Suspense
        fallback={<Spinner color="#222" style={{ marginTop: 20 }} />}
      >
        {userContext.token ? (
          <Main userContext={userContext} setUserContext={setUserContext} />
        ) : (
          <div>
            <div className="content">
              <Routes>
                <Route
                  exact
                  path="/"
                  index
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <Login />
                    </React.Suspense>
                  }
                />
                <Route
                  path="*"
                  element={
                    <React.Suspense
                      fallback={
                        <Spinner color="#222" style={{ marginTop: 20 }} />
                      }
                    >
                      <Login />
                    </React.Suspense>
                  }
                />
              </Routes>
            </div>
          </div>
        )}
      </React.Suspense>
      <Footer />
    </div>
  );
}
const AppWrapper = () => (
  <AuthProvider>
    <ReqCallProvider>
      <Router>
        <App />
      </Router>
    </ReqCallProvider>
  </AuthProvider>
);
export default AppWrapper;
